<template>
    <button
        type="button"
        role="button"
        class="btn-default btn-default--3 btn-default--icon"
        :class="`btn-${props.direction}`"
        @click="props.direction === 'prev' ? swiper.slidePrev() : swiper.slideNext()"
        :style="`color: ${props.item?.CaseColour}`"
        ref="navButton">
        <svgComponent
            :width="24"
            :height="24"
            class-name="icon-next"
            :icon-name="props.direction === 'prev' ? 'arrow-left' : 'arrow-right'"></svgComponent>
    </button>
</template>

<script lang="ts">
import { useSwiper } from 'swiper/vue';
import svgComponent from '../../../components/svgComponent.vue';

export default {
    props: {
        direction: String,
        item: Object,
    },
    components: {
        svgComponent,
    },
    setup(props) {
        const swiper = useSwiper();

        return {
            props,
            swiper,
        };
    },
};
</script>
